export default class AccordionWithVisuals extends HTMLElement {
    constructor() {
        super();
        this.overMaxHeight = 25; // px
        this.tabItems = [];
        this.classOpened = 'open'
    }

    onSelectTab(tabId) {
        const tabSelected = this.querySelector(`.tab-item[data-id="${tabId}"]`)
        const currentSelected = this.querySelector(`.tab-item.${this.classOpened}`)

        if (tabSelected && !tabSelected.classList.contains(this.classOpened)) {
            tabSelected.classList.add(this.classOpened);

            if (currentSelected) {
                currentSelected.classList.remove(this.classOpened);
            }

            this.dispatchEvent(new CustomEvent('ON_TAB_SELECTED', { detail: { tabId } }))
        }
    }

    buildTabs() {
        this.tabItems = this.querySelectorAll('.tab-item');
        this.tabItems && this.tabItems.forEach(this.initTab.bind(this));
    }

    initTab(item) {
        const button = item.querySelector('button');
        const descEl = item.querySelector('.tab-header .description-wrapper');
        const contentEl = item.querySelector('.tab-content');

        if (descEl) {
            item.style.setProperty('--desc-max-height', `${descEl.scrollHeight + this.overMaxHeight}px`)
        }
        if (contentEl) {
            item.style.setProperty('--content-max-height', `${contentEl.scrollHeight + this.overMaxHeight}px`)
        }
        button.addEventListener('click', this.onSelectTab.bind(this, item.dataset.id))
    }

    init() {
        window.addEventListener('resize', this.buildTabs.bind(this));
        this.buildTabs();
        this.onSelectTab(0)
    }

    connectedCallback() {
        document.addEventListener("readystatechange", (event) => {
            if (event.target.readyState === 'complete') {
                this.init();
            }
        });
    }
}

